import { useEffect, useState } from 'react';

// ------------------------------------------------------------------------------------

type UseDisclosureProps = {
  initialState?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};

const useDisclosure = ({ initialState = false, onOpen, onClose }: UseDisclosureProps) => {
  const [isOpen, setIsOpen] = useState(initialState);

  useEffect(() => {
    if (isOpen !== initialState) {
      setIsOpen(initialState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState]);

  const open = () => {
    setIsOpen(true);
    onOpen?.();
  };

  const close = () => {
    setIsOpen(false);
    onClose?.();
  };

  const toggle = () => (isOpen ? close() : open());

  return { isOpen, open, close, toggle };
};

export default useDisclosure;
